import {ToolApi} from "../../../../util/ToolApi.tsx";
import {errorText} from "../../scan-operations/error/ErrorText.ts";

function extractStackTrace(error: unknown): string {
    if(!error) return "-"
    if(!(error instanceof Error)) return "Error was not of type error"
    return error.stack ?? "No stack trace"
}

export async function postError(message: string, options: object, error?: unknown) {
    try {
        const stackTrace = extractStackTrace(error)
        await ToolApi.post("log-error", {
            message,
            errorText: error ? errorText(error) : "-",
            stackTrace,
            analysisOptions: options
        })
    } catch(e) {
        console.error("An error occurred while uploading error details", e)
    }
}